import { getAssetUrl } from '@/utils/common';
type dynastyImagesProps = {
  dynasty: string;
  images: string[];
}

export const getRandomItems = (originalArray: any, chunkSize: number) => {
  const resultArray = [];
  for (let i = 0; i < originalArray.length; i += chunkSize) {
    resultArray.push(originalArray.slice(i, i + chunkSize));
  }
  return resultArray;
};

export const postionsList = [
  {
    top: 0,
    left: 100,
  },
  {
    top: 0,
    right: 100,
  },
  {
    top: 230,
    left: 0,
  },
  {
    top: 230,
    right: 0,
  },
  {
    top: 460,
    left: 0,
  },
  {
    top: 460,
    right: 0,
  },
  {
    top: 690,
    left: 100,
  },
  {
    top: 690,
    right: 100,
  }
];

// export const postionsList = [
//   {
//     index: 1,
//     postion: {
//       top: 0,
//       left: 100,
//     }
//   },
//   {
//     index: 2,
//     postion: {
//       top: 0,
//       right: 100,
//     }
//   }, {
//     index: 3,
//     postion: {
//       top: 230,
//       left: 0,
//     }
//   }, {
//     index: 4,
//     postion: {
//       top: 230,
//       right: 0,
//     }
//   }, {
//     index: 5,
//     postion: {
//       top: 460,
//       left: 0,
//     }
//   }, {
//     index: 6,
//     postion: {
//       top: 460,
//       right: 0,
//     }
//   }, {
//     index: 7,
//     postion: {
//       top: 690,
//       left: 100,
//     }
//   }, {
//     index: 8,
//     postion: {
//       top: 690,
//       right: 100,
//     }
//   }

// ]